import React from 'react';
import DekorInput from '../commons/DekorInput.jsx'
import GriffInput from '../commons/GriffInput.jsx'
import RadioGroup from '../commons/RadioGroup.jsx'
import Helper from "../../../model/Helper";
import SidebarFrame from "./SidebarFrame";
import Select from "../commons/Select";
import NumberInput from "../commons/NumberInput";

export default class SchwebetuerenSettings extends SidebarFrame {

    state = {
        schwebetuerIndex: null
    }

    renderTitle() {
        return I18N("Schwebetüren");
    }

    renderBody() {
        const schrank = APP.arrangement.schraenke[APP.arrangement.currentSchrankIndex];
        const schwebetuer = schrank.schwebetuer;
        const schwebetuerIterator = (callback)=>this.state.schwebetuerIndex==null
            ? schwebetuer.schwebetuerFluegel.forEach(schwebetuer=>callback(schwebetuer))
            : callback(schwebetuer.schwebetuerFluegel[this.state.schwebetuerIndex]);
        const schwebetuerFluegel = schwebetuer.schwebetuerFluegel[this.state.schwebetuerIndex||0];
        const schwebetuerAuswahl = [];
        for (let i=0; i<schwebetuer.schwebetuerFluegel.length; i++) {
            schwebetuerAuswahl.push({value:i, label:i+1});
        }

        return (
            <div>

                {APP.arrangement.isSchwebetuer() && (
                    <Select value={this.state.schwebetuerIndex}
                            options={[{value:null,label:I18N('alle')}].concat(_.range(schwebetuer.schwebetuerFluegel.length).map(i=>({value:i, label:I18N(`Schwebetuer ${i+1}`)})))}
                            onChange={value=>{
                                this.setState({schwebetuerIndex: value});
                                this.forceUpdate();
                            }}
                            label={I18N("Schwebetuer")}/>
                )}


                {APP.arrangement.isSchwebetuer() && (
                <Select value={schwebetuerFluegel.decorType}
                        options={[
                            {value:'standard',label:I18N('Tür Standard')},
                            {value:'spiegel',label:I18N('Tür mit Spiegel')},
                            {value:'decor',label:I18N('Tür mit Dekorstreifen feste Höhe')},
                            {value:'decorDrittel',label:I18N('Tür mit Dekorstreifen drittel Höhe')},
                        ]}
                        onChange={value=>{
                            schwebetuerIterator(schwebetuer=>schwebetuer.decorType=value);
                            this.forceUpdate();
                            APP.model.setDirty();
                        }}
                        label={I18N("Art festlegen")}/>
                )}


                {APP.arrangement.isSchiebetuerVorneAuswahl() && (
                    <Select label={I18N("Welche Tür soll vorne stehen?")}
                            value={APP.arrangement.schiebetuerLinksVorne}
                            options={[
                                {
                                    label: I18N('linke Tür hinten'),
                                    value: false
                                },
                                {
                                    label: I18N('linke Tür vorne'),
                                    value: true
                                }
                            ]}
                            onChange={APP.model.tryWrap(this,value=>APP.arrangement.schiebetuerLinksVorne=value)} />
                )}

                {APP.arrangement.hasSchliessDaempfungsOption() && (

                    <Select label={I18N("Tür mit Schließdämpfung")}
                            value={APP.arrangement.schliessdaempfung}
                            options={[
                                {
                                    label: I18N('Nein'),
                                    value: false
                                },
                                {
                                    label: I18N('Ja'),
                                    value: true
                                }
                            ]}
                            onChange={APP.model.tryWrap(this,value=>APP.arrangement.schliessdaempfung=value)}/>

                )}

                {schwebetuer.schwebetuerFluegel.length>2 && (

                    <Select label={I18N("in welche Richtung soll die mittlere Tür laufen")}
                            value={APP.arrangement.fluegelanordungLinks}
                            options={[
                                {
                                    label: I18N('nach rechts'),
                                    value: false
                                },
                                {
                                    label: I18N('nach links'),
                                    value: true
                                }
                            ]}
                            onChange={APP.model.tryWrap(this,value=>APP.arrangement.fluegelanordungLinks=value)}/>
                )}

            </div>
        )
    }
}